import { CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import { appTheme } from './app-theme';
export var UIThemeProvider = function (_a) {
    var children = _a.children;
    return (React.createElement(ThemeProvider, { theme: appTheme },
        React.createElement(CssBaseline, null),
        children));
};
